/* eslint-disable jsx-a11y/anchor-is-valid */
import {StepProps} from '../IAppModels'

const Step3 = ({data, updateData, hasError, errorMessage, searchedProposals}: StepProps) => {
  return (
    <>
      <div data-kt-stepper-element='content'>
        <table className='table table-hover table-rounded table-striped border gy-7 gs-7'>
          <thead>
            <tr className='fw-bold fs-6 text-gray-800 border-bottom border-gray-200'>
              <th>Número da proposta</th>
              <th>Nome do cliente</th>
              <th>CPF/CNPJ do cliente</th>
              <th>ID Caixa</th>
              <th>ID Documento</th>
              <th>Recepcionado</th>
            </tr>
          </thead>
          <tbody>
            {searchedProposals?.map((proposal) => (
              <tr>
                <td>{proposal.numeroProposta}</td>
                <td>{proposal.nomeCliente}</td>
                <td>
                  {proposal.cpfCliente
                    ?.toString()
                    .replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')}
                </td>
                <td>
                  {/* <input
                    type='text'
                    name='id_caixa'
                    onChange={(e) =>
                      proposal.numeroProposta &&
                      updateIdCaixaSelectedProposals(proposal.numeroProposta, e.target.value)
                    }
                    placeholder='Digite o ID da caixa'
                    autoComplete='off'
                    className='form-control form-control-lg form-control-solid'
                  /> */}
                  {data.selectedProposals.find((p) => p.Proposta === proposal.id)?.id_caixa}
                </td>
                <td>
                  {data.selectedProposals.find((p) => p.Proposta === proposal.id)?.id_documento}
                </td>
                <td>
                  {data.selectedProposals.some((p) => proposal.id === p.Proposta) ? 'Sim' : 'Não'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  )
}

export {Step3}
